var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { normalizeLocale, resolveConfig } from "./config";
import { configureHttp } from "./core/http";
import { buildLoginUrl, clearAuthCookie, getAuthToken, validateReturnUrl } from "./core/session";
import { loadWidgetModule } from "./widget-module";
/**
 * 创建暴露给业务方使用的认证 API。
 */
export const createPublicApi = () => {
    const baseConfig = resolveConfig();
    configureHttp(baseConfig);
    /**
     * 安全执行外部回调，避免业务方回调异常影响认证组件内部流程。
     */
    const safeCall = (callback) => {
        try {
            callback === null || callback === void 0 ? void 0 : callback();
        }
        catch (error) {
            console.error("[SmmAuth] callback failed", error);
        }
    };
    /**
     * 将认证组件内部错误通知给业务方传入的 onError 回调。
     */
    const notifyError = (options, error) => {
        var _a;
        try {
            (_a = options === null || options === void 0 ? void 0 : options.onError) === null || _a === void 0 ? void 0 : _a.call(options, error);
        }
        catch (cause) {
            console.error("[SmmAuth] onError callback failed", cause);
        }
    };
    /**
     * 打开登录弹窗。
     */
    const showLogin = (options) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const language = normalizeLocale(options === null || options === void 0 ? void 0 : options.language);
            const returnUrl = validateReturnUrl((options === null || options === void 0 ? void 0 : options.returnUrl) || window.location.href, window.location.href);
            const { ensureWidgetLoaded, openWidget } = yield loadWidgetModule();
            yield ensureWidgetLoaded();
            yield openWidget(baseConfig, Object.assign(Object.assign({ action: "login" }, (options || {})), { language,
                returnUrl }), (reason) => {
                if (reason === "cancel")
                    safeCall(options === null || options === void 0 ? void 0 : options.onCancel);
            });
        }
        catch (cause) {
            const error = {
                message: (cause === null || cause === void 0 ? void 0 : cause.message) || "Unable to open auth widget",
                cause,
            };
            notifyError(options, error);
            throw cause;
        }
    });
    /**
     * 处理登录态失效：清除本地认证 Cookie 并尝试打开登录弹窗，
     * 弹窗打开失败时降级跳转到用户中心登录页。
     */
    const handleAuthInvalid = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (options = {}) {
        clearAuthCookie(baseConfig);
        try {
            yield showLogin({
                action: "login",
                returnUrl: options.returnUrl,
                onError: () => redirectToLogin({ returnUrl: options.returnUrl }),
            });
        }
        catch (_a) {
            redirectToLogin({ returnUrl: options.returnUrl });
        }
    });
    /**
     * 构建用户中心登录地址并跳转，支持指定动作、语言和登录后的返回地址。
     */
    const redirectToLogin = (options = {}) => {
        const language = normalizeLocale(options.language);
        const returnUrl = validateReturnUrl(options.returnUrl || window.location.href, window.location.href);
        window.location.href = buildLoginUrl({
            userCenterUrl: baseConfig.userCenterUrl,
            locale: language,
            action: options.action || "login",
            returnUrl,
        });
    };
    return {
        showLogin,
        handleAuthInvalid,
        // 获取当前认证 Token。
        getToken: () => getAuthToken(baseConfig),
        // 根据当前是否存在认证 Token 判断用户是否已登录。
        isLoggedIn: () => !!getAuthToken(baseConfig),
        // 清除认证 Cookie，退出当前登录态。
        logout: () => clearAuthCookie(baseConfig),
        redirectToLogin,
    };
};
//# sourceMappingURL=public-api.js.map